var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRaio = function SvgRaio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#113c64"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffca05",
    d: "M386 79.2H206L101 282.3h131l-37.5 173.9L386 224.4h-74.4L386 79.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2a221",
    d: "M311.6 224.4H386L261.6 375.1V79.2H386l-74.4 145.2z"
  })));
};
export { SvgRaio as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+PGNpcmNsZSBjeD0iMjU2IiBjeT0iMjU2IiByPSIyNTYiIGZpbGw9IiMxMTNjNjQiLz48cGF0aCBkPSJNMzg2IDc5LjJIMjA2TDEwMSAyODIuM2gxMzFsLTM3LjUgMTczLjlMMzg2IDIyNC40aC03NC40TDM4NiA3OS4yeiIgZmlsbD0iI2ZmY2EwNSIvPjxwYXRoIGQ9Ik0zMTEuNiAyMjQuNEgzODZMMjYxLjYgMzc1LjFWNzkuMkgzODZsLTc0LjQgMTQ1LjJ6IiBmaWxsPSIjZjJhMjIxIi8+PC9zdmc+";